export const translations = {
    EN: {
      nav: {
        about: 'About',
        gallery: 'Gallery',
        contact: 'Contact',
      },
      intro: {
        skip: 'skip',
      },
      categories: {
        travel: 'Travel',
        portraits: 'Portraits',
        street: 'Street',
      },
      contact: {
        headlineLine1: 'PHOTOGRAPHY?',
        headlineLine2: 'LET\u2019S TALK',
        email: 'Email',
        instagram: 'Instagram',
        location: 'Location',
        locationValue: 'Wroc\u0142aw, Poland',
      },
      about: {
        p1: 'I\u2019m Piotr Szka\u0142uba, the photographer behind Positive Grain, based in Wroc\u0142aw, Poland.',
        p2: 'I create portrait, travel, and documentary photography using both digital and 35mm film. My work is guided by natural light, genuine moments, and timeless images that feel authentic rather than staged.',
        p3: 'Positive Grain reflects the philosophy behind my work\u2014a quiet nod to analogue photography and the beauty of texture, character, and imperfection.',
        p4: 'Whether you\u2019re looking for a portrait photographer, authentic photography for your personal brand or small business, or a 35mm film photographer, I\u2019d be happy to create photographs that tell your story.',
        p5: 'Based in Wroc\u0142aw, I\u2019m available for portrait sessions and photography projects throughout Poland.',
      },
      cookie: {
        text: 'We use cookies to provide our services at the highest level. Using this website means they will be placed on your device. You can change your browser settings at any time.',
        policyLink: 'See Cookie Policy',
        acceptAll: 'Accept All',
        settings: 'Settings',
        essentialOnly: 'Essential Only',
        essentialLabel: 'Essential',
        functionalLabel: 'Functional',
        analyticsLabel: 'Analytics',
        marketingLabel: 'Marketing',
        savePreferences: 'Save preferences',
      },
    },
    PL: {
      nav: {
        about: 'O mnie',
        gallery: 'Galeria',
        contact: 'Kontakt',
      },
      intro: {
        skip: 'pomiń',
      },
      categories: {
        travel: 'Podr\u00f3\u017ce',
        portraits: 'Portrety',
        street: 'Ulica',
      },
      contact: {
        headlineLine1: 'FOTOGRAFIA?',
        headlineLine2: 'POROZMAWIAJMY',
        email: 'Email',
        instagram: 'Instagram',
        location: 'Lokalizacja',
        locationValue: 'Wroc\u0142aw, Polska',
      },
      about: {
        p1: 'Nazywam si\u0119 Piotr Szka\u0142uba, jestem fotografem stoj\u0105cym za Positive Grain, z siedzib\u0105 we Wroc\u0142awiu.',
        p2: 'Tworz\u0119 fotografi\u0119 portretow\u0105, podr\u00f3\u017cnicz\u0105 i dokumentaln\u0105, korzystaj\u0105c zar\u00f3wno z aparatu cyfrowego, jak i filmu 35mm. W mojej pracy kieruj\u0119 si\u0119 naturalnym \u015bwiat\u0142em, autentycznymi chwilami i ponadczasowymi zdj\u0119ciami, kt\u00f3re s\u0105 prawdziwe, a nie wystylizowane.',
        p3: 'Positive Grain odzwierciedla filozofi\u0119 stoj\u0105c\u0105 za moj\u0105 prac\u0105 \u2014 subtelne nawi\u0105zanie do fotografii analogowej i pi\u0119kna faktury, charakteru oraz niedoskona\u0142o\u015bci.',
        p4: 'Niezale\u017cnie od tego, czy szukasz fotografa portretowego, autentycznych zdj\u0119\u0107 dla swojej marki osobistej lub ma\u0142ej firmy, czy fotografa analogowego \u2014 ch\u0119tnie stworz\u0119 zdj\u0119cia, kt\u00f3re opowiedz\u0105 Twoj\u0105 histori\u0119.',
        p5: 'Z siedzib\u0105 we Wroc\u0142awiu, jestem dost\u0119pny na sesje portretowe i projekty fotograficzne na terenie ca\u0142ej Polski.',
      },
      cookie: {
        text: 'U\u017cywamy plik\u00f3w cookie, aby \u015bwiadczy\u0107 nasze us\u0142ugi na najwy\u017cszym poziomie. Korzystanie z tej strony oznacza, \u017ce b\u0119d\u0105 one umieszczane na Twoim urz\u0105dzeniu. Mo\u017cesz zmieni\u0107 ustawienia przegl\u0105darki w dowolnym momencie.',
        policyLink: 'Zobacz Polityk\u0119 Cookies',
        acceptAll: 'Akceptuj wszystkie',
        settings: 'Ustawienia',
        essentialOnly: 'Tylko niezb\u0119dne',
        essentialLabel: 'Niezb\u0119dne',
        functionalLabel: 'Funkcjonalne',
        analyticsLabel: 'Analityczne',
        marketingLabel: 'Marketingowe',
        savePreferences: 'Zapisz preferencje',
      },
    },
  } as const;
  
  export type TranslationShape = typeof translations.EN;